module.exports = __webpack_public_path__ + "img/34-r.0ea96f45.png";